var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:['c-lazy-image', _vm.round ? 'is-round' : ''],style:(_vm.style),attrs:{"src":_vm.blankPlaceholder,"data-src":_vm.lazySrc,"data-srcset":_vm.lazySrcset}})}
var staticRenderFns = []

export { render, staticRenderFns }